import { useEffect, useState } from "react";

export default function useIsDpcDoubled() {
    const [isDoubled, setIsDoubled] = useState(false);

    useEffect(() => {
        setIsDoubled(!!window.localStorage.getItem('dpcDoubled'));
    }, []);

    return isDoubled;
}